//
//
//
//
//
//
//

import Tinymce from '@/components/Tinymce/index';
import { getToken } from '@/utils/auth';
export default {
  name: 'c_page_ueditor',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    }
  },
  components: {
    Tinymce: Tinymce
  },
  data: function data() {
    // const url = SettingMer.https + '/upload/image/0/file?ueditor=1&token=' + getToken()
    return {
      myConfig: {
        autoHeightEnabled: false,
        // 编辑器不自动被内容撑高
        initialFrameHeight: 350,
        // 初始容器高度
        initialFrameWidth: '100%',
        // 初始容器宽度
        UEDITOR_HOME_URL: '/UEditor/',
        imageFieldName: 'file',
        imageUrlPrefix: '',
        imageActionName: 'upfile',
        imageMaxSize: 2048000,
        imageAllowFiles: ['.png', '.jpg', '.jpeg', '.gif', '.bmp']
      },
      description: '',
      defaults: {},
      configData: {},
      newVal: '',
      keyIndex: 0
    };
  },
  created: function created() {
    this.defaults = this.configObj;
    this.configData = this.configObj[this.configNme];
    this.newVal = this.configData.val;
  },
  watch: {
    configObj: {
      handler: function handler(nVal, oVal) {
        //  this.keyIndex += 1;
        this.defaults = nVal;
        this.configData = nVal[this.configNme];
        this.newVal = nVal[this.configNme].val || '';
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    changeTinymce: function changeTinymce() {
      this.keyIndex += 1;
    },
    tinymceInput: function tinymceInput(info) {
      //   this.newVal = info

      this.$emit('getConfig', info);
      this.configData.val = info;
    },
    // 获取组件参数
    getConfig: function getConfig(data) {}
  }
};